import { render } from "./ImageSelector.vue?vue&type=template&id=f6cdda10"
import script from "./ImageSelector.vue?vue&type=script&lang=js"
export * from "./ImageSelector.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__